export default __webpack_public_path__ + "static/media/arrow-up-bold-filled.db644912.svg";